export const Config = {
  sentryDSN: 'https://9cfede3ad16e47bf8b75afdbfbe54c1e@sentry.io/1794973'
}
